import fetch from "lib/fetch";
import { AdApplicationInterface, AdInterface } from "types/ad";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type AdResponse = { data: AdInterface };
type AdApplicationResponse = { data: AdApplicationInterface };

export const getAdsRequest = (params?: HashMap<unknown>) => fetch.get<ListResponse<AdInterface>>("ad", { params });

export const getAdRequest = (id: string) => fetch.get<AdResponse>(`ad/${id}`);

export const getAdApplicationsRequest = (id: string) => fetch.get<ListResponse<AdApplicationInterface>>(`ad/${id}/applications`);

export const createAdRequest = (data: HashMap<unknown>) => fetch.post<AdResponse>("ad", data);

export const updateAdRequest = (id: string, data: HashMap<unknown>) => fetch.put<AdResponse>(`ad/${id}`, data);

export const confirmAdApplyRequest = (adId: string, data: HashMap<unknown>) =>
    fetch.post<AdResponse>(`ad/${adId}/apply/confirm`, data);

export const refuseAdApplyRequest = (adId: string, data: HashMap<unknown>) =>
    fetch.post<AdResponse>(`ad/${adId}/apply/refuse`, data);

export const deleteAdRequest = (id: string) => fetch.delete<AdResponse>(`ad/${id}`);

export const patchAdRequest = (id: string, data: HashMap<unknown>) => fetch.patch<AdResponse>(`ad/${id}`, data);

export const getOurAdsRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<AdInterface>>("our_ad", { params });

export const getOurAdRequest = (id: string) => fetch.get<AdResponse>(`our_ad/${id}`);

export const applyToOurAdRequest = (adId: string, serviceId: string, data: HashMap<unknown>) =>
    fetch.post<AdApplicationResponse>(`our_ad/${adId}/${serviceId}/apply`, data);

export const getOurAdApplicationsRequest = () =>
    fetch.get<ListResponse<AdApplicationInterface>>("our_ad/applications");
